import {React} from 'external/react'
import { styled, Box} from 'external/material'
import {AssignedContentIcon} from 'resources/icons'

const StyledInfoBar = styled(Box)(({theme}) => ({
  display: 'flex',
  borderBottom: 'solid 1px #dbe3e6',
  minHeight: '60px',
  paddingLeft: '15px',
  '& .middle': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  '& .label': {
    paddingTop: '4px',
    marginLeft: '20px',
    fontSize: '14pt',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(15),
    },
  },
}))

export default function InfoBar ({context}) {

  const {quizAssessmentToAssign} = context
  return (
    <StyledInfoBar>
      <Box className="middle">
        <AssignedContentIcon fill="#4f576e" />
      </Box>
      <Box className="middle label">
        {quizAssessmentToAssign.title}
      </Box>
    </StyledInfoBar>
  )
}
